import type { SVGProps } from 'react';
const SvgCreatorTelegram = ({ width = 16, height = 16, ...props }: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <rect width={16} height={16} fill="#33A4EB" rx={8} />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M3.619 6.874a363 363 0 0 1 4.833-2.512c2.301-1.155 2.78-1.355 3.091-1.362a.48.48 0 0 1 .321.116.46.46 0 0 1 .118.271c.011.078.025.255.014.394-.125 1.581-.664 5.418-.939 7.19-.116.749-.345 1-.566 1.024-.482.054-.847-.383-1.313-.752-.73-.577-1.142-.936-1.85-1.499-.818-.65-.287-1.008.179-1.593.122-.153 2.242-2.48 2.283-2.691.006-.026.01-.125-.038-.177-.049-.052-.12-.034-.172-.02q-.11.03-3.495 2.788-.496.412-.899.4c-.296-.007-.865-.201-1.288-.367-.52-.204-.932-.311-.896-.657q.028-.27.617-.553"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgCreatorTelegram;
